<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="cests"
        :headers="headers"
        :rotina-id="ID_TELA_DE_CEST"
        :configurar="false"
        :loading="loading"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarCEST()"
        @update="(indice) => abrirDialogEditarCEST(indice)"
        @delete="(indice) => openDialogDeleteCEST(indice)"
      >
        <template #[`item.dataInicio`]="{ item }">
          {{ formatDate(item.dataInicio) }}
        </template>

        <template #[`item.dataFim`]="{ item }">
          {{ formatDate(item.dataFim) }}
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeCEST
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :cest-param="cestParam"
        :itens="itensParam"
        @confirmado="atualizarCEST"
      />
      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteCEST" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="cestDelete">
            Tem certeza que deseja excluir o CEST <b> {{ cestDelete.descricao }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteCEST = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="removerCEST">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CESTService from '@/services/cest/cest'
import SnackbarMessage from '@/components/SnackbarMessage'
import DialogDeEdicaoDeCEST from '@/components/cests/DialogDeEdicaoDeCEST'
import DataTableDeCrud from '@/components/DataTableDeCrud'
import SnackBar from '@/models/components/snackbar'
import CEST from '@/models/cest'
import SegmentoService from '@/services/segmento/segmento'
import NCMService from '@/services/ncm/ncm'
import { ID_TELA_DE_CEST } from '@/common/constants'
import { formatDate } from '@/shareds/formatacoes'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeCEST
  },

  props: ['buscaParam'],

  data: () => ({
    name: 'TelaDeCEST',
    headers: [
      { text: 'Código', value: 'codigo' },
      { text: 'Descrição', value: 'descricao', width: '400' },
      { text: 'Início', value: 'dataInicio' },
      { text: 'Fim', value: 'dataFim' },
      { text: 'Segmento', value: 'segmento.descricao' },
      { text: 'NCM', value: 'ncm.codigo' }
    ],
    cests: [],
    loading: false,
    validForm: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    cestParam: new CEST(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteCEST: false,
    cestDelete: new CEST(),
    indiceCESTDelete: 0,
    itensSegmento: [],
    itensNCM: [],
    ID_TELA_DE_CEST: ID_TELA_DE_CEST,
    formatDate: formatDate
  }),

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        if (this.$route.query.id) {
          CESTService.getById(this.$route.query.id).then((response) => this.cests.push(response))
        } else {
          this.loadCESTs()
        }

        this.loadSegmentos()
        this.loadNCMs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível encontrar CESTs cadastrados.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadCESTs() {
      this.loading = true
      const response = await CESTService.getAll()
      this.cests = response.map((item) => ({
        ...item
      }))
      this.loading = false
    },

    async loadSegmentos() {
      const response = await SegmentoService.getAll()
      this.itensSegmento = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    async loadNCMs() {
      const response = await NCMService.getAll()
      this.itensNCM = response.map((item) => ({
        text: item.codigo + ' - ' + item.descricao,
        value: item.id
      }))
    },

    atualizarCEST(cest) {
      if (!cest) return

      const indice = this.cests.findIndex((cestExistente) => cestExistente.id === cest.id)

      if (indice === -1) {
        this.cests.push(cest)
        this.snackbar.snackTextParam = 'CEST criado com sucesso.'
      } else {
        this.cests.splice(indice, 1, cest)
        this.snackbar.snackTextParam = 'CEST atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteCEST(indice) {
      this.cestDelete = this.cests[indice]
      if (!this.cestDelete.id) return

      this.indiceCESTDelete = indice
      this.dialogDeleteCEST = true
    },

    async removerCEST() {
      try {
        await CESTService.deleteById(this.cestDelete.id)
        this.snackbar.snackTextParam = 'CEST removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.cests.splice(this.indiceCESTDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível excluir o CEST.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteCEST = false
    },

    abrirDialogCriarCEST() {
      this.operacao = 'adicionar'
      this.itensParam = { segmento: this.itensSegmento, ncm: this.itensNCM }
      this.cestParam = new CEST()
      this.showDialogParam = true
    },

    abrirDialogEditarCEST(indice) {
      this.operacao = 'editar'
      this.itensParam = { segmento: this.itensSegmento, ncm: this.itensNCM }
      this.cestParam = { ...this.cests[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
